const rawConferenceProducts = [
  {
    id: "spon-lcm-6010",
    brand: "Spoon",
    systemType: "both",
    componentType: "master-control-unit",
    productName: "Master Control Unit (Wired/Wireless)",
    model: "LCM-6010",
    unit: "Nos.",
    unitPrice: 91070.7,
  },
  {
    id: "spon-lcm-6013cv-l",
    brand: "Spoon",
    systemType: "wired",
    componentType: "chairman-unit",
    productName: "Chairman Unit (Wired)",
    model: "LCM-6013CV-L",
    unit: "Nos.",
    unitPrice: 27283.73,
  },
  {
    id: "spon-lcm-6013dv-l",
    brand: "Spoon",
    systemType: "wired",
    componentType: "delegate-unit",
    productName: "Delegate Unit (Wired)",
    model: "LCM-6013DV-L",
    unit: "Nos.",
    unitPrice: 27283.73,
  },
  {
    id: "spon-lcm-6013cvw-l",
    brand: "Spoon",
    systemType: "wireless",
    componentType: "chairman-unit",
    productName: "Chairman Unit (Wireless)",
    model: "LCM-6013CVW-L",
    unit: "Nos.",
    unitPrice: 13000,
  },
  {
    id: "spon-lcm-6013dvw-l",
    brand: "Spoon",
    systemType: "wireless",
    componentType: "delegate-unit",
    productName: "Delegate Unit (Wireless)",
    model: "LCM-6013DVW-L",
    unit: "Nos.",
    unitPrice: 12000,
  },
  {
    id: "spon-d14001",
    brand: "Spoon",
    systemType: "both",
    componentType: "gooseneck-microphone",
    productName: "Gooseneck Microphone",
    model: "D14001",
    unit: "Nos.",
    unitPrice: 6381.38,
  },
  {
    id: "spon-lcs-5301z",
    brand: "Spoon",
    systemType: "wireless",
    componentType: "wireless-access-point",
    productName: "Wireless Access Point",
    model: "LCS-5301Z",
    unit: "Nos.",
    unitPrice: 10000,
  },
  {
    id: "spon-sap-f88e",
    brand: "Spoon",
    systemType: "both",
    componentType: "digital-audio-processor",
    productName: "Digital Audio Processor",
    model: "SAP-F88E",
    unit: "Nos.",
    unitPrice: 45535.35,
  },
  {
    id: "spon-gen-5301p26",
    brand: "Spoon",
    systemType: "wired",
    componentType: "network-integrated-amplifier",
    productName: "Network Integrated Amplifier",
    model: "GEN-5301P26",
    unit: "Nos.",
    unitPrice: 66491.25,
  },
  {
    id: "spon-gen-5301p13",
    brand: "Spoon",
    systemType: "wireless",
    componentType: "network-integrated-amplifier",
    productName: "Network Integrated Amplifier",
    model: "GEN-5301P13",
    unit: "Nos.",
    unitPrice: 60779.25,
  },
  {
    id: "spon-lcm-6015p",
    brand: "Spoon",
    systemType: "wireless",
    componentType: "wireless-charging-station",
    productName: "Wireless Charging Station",
    model: "LCM-6015P",
    unit: "Nos.",
    unitPrice: 17000,
  },
  {
    id: "spon-nac-720w",
    brand: "Spoon",
    systemType: "both",
    componentType: "wall-speaker",
    productName: "Wall Speaker",
    model: "NAC-720W",
    unit: "Nos.",
    unitPrice: 13574.93,
  },
  {
    id: "spon-nac-111",
    brand: "Spoon",
    systemType: "both",
    componentType: "ceiling-speaker",
    productName: "Ceiling Speaker",
    model: "NAC-111",
    unit: "Nos.",
    unitPrice: 6500,
  },
  {
    id: "honeywell-hcs-csc1",
    brand: "Honeywell",
    systemType: "wired",
    componentType: "master-control-unit",
    productName: "Main Control Unit",
    model: "HCS-CSC1",
    unit: "Nos",
    unitPrice: 103856,
  },
  {
    id: "honeywell-hcs-c01cp",
    brand: "Honeywell",
    systemType: "wired",
    componentType: "chairman-unit",
    productName: "Chairman Microphone",
    model: "HCS-C01CP",
    unit: "Nos",
    unitPrice: 40115,
  },
  {
    id: "honeywell-hcs-c01dp",
    brand: "Honeywell",
    systemType: "wired",
    componentType: "delegate-unit",
    productName: "Delegate Microphone",
    model: "HCS-C01DP",
    unit: "Nos",
    unitPrice: 38636,
  },
  {
    id: "honeywell-hn-5240r",
    brand: "Honeywell",
    systemType: "wired",
    componentType: "network-integrated-amplifier",
    productName: "240W Mixer Amplifier",
    model: "HN-5240R",
    unit: "Nos",
    unitPrice: 83423,
  },
  {
    id: "honeywell-cs-718",
    brand: "Honeywell",
    systemType: "wired",
    componentType: "wall-speaker",
    productName: "8\" 10W ABS Ceiling Speaker",
    model: "CS-718",
    unit: "Nos",
    unitPrice: 2556,
  },
  {
    id: "honeywell-conference-accessories",
    brand: "Honeywell",
    systemType: "wired",
    componentType: "accessories",
    productName: "Accessories",
    model: "Conference Accessories",
    unit: "Lot",
    unitPrice: 12000,
  },
  {
    id: "honeywell-conference-installation",
    brand: "Honeywell",
    systemType: "wired",
    componentType: "installation-service",
    productName: "Installation Testing and Commissioning",
    model: "Installation Service",
    unit: "Job",
    unitPrice: 15000,
  },
  {
    id: "bosch-ccsd-cu",
    brand: "Bosch",
    systemType: "wired",
    componentType: "master-control-unit",
    productName: "Master Control Unit",
    model: "CCSD-CU",
    unit: "Nos.",
    unitPrice: 290250,
  },
  {
    id: "bosch-ccsd-dl-chairman",
    brand: "Bosch",
    systemType: "wired",
    componentType: "chairman-unit",
    productName: "Chairman Unit",
    model: "CCSD-DL",
    unit: "Nos.",
    unitPrice: 68850,
  },
  {
    id: "bosch-ccsd-dl-delegate",
    brand: "Bosch",
    systemType: "wired",
    componentType: "delegate-unit",
    productName: "Delegate Unit",
    model: "CCSD-DL",
    unit: "Nos.",
    unitPrice: 68175,
  },
  {
    id: "bosch-ima120",
    brand: "Bosch",
    systemType: "wired",
    componentType: "network-integrated-amplifier",
    productName: "Amplifier",
    model: "IMA120",
    unit: "Nos.",
    unitPrice: 70200,
  },
  {
    id: "bosch-lb2-uc30",
    brand: "Bosch",
    systemType: "wired",
    componentType: "wall-speaker",
    productName: "30watt Wall Speaker",
    model: "LB2-UC30",
    unit: "Nos.",
    unitPrice: 24705,
  },
  {
    id: "generic-speaker-cable",
    brand: "Generic",
    systemType: "both",
    componentType: "speaker-cable",
    productName: "Speaker Cable",
    model: "Speaker Cable",
    unit: "Mtr",
    unitPrice: 53.55,
  },
  {
    id: "generic-xlr-cable-10m",
    brand: "Generic",
    systemType: "both",
    componentType: "xlr-cable",
    productName: "XLR Cable (10M)",
    model: "10M",
    unit: "Nos",
    unitPrice: 1890,
  },
  {
    id: "generic-conference-accessories",
    brand: "Generic",
    systemType: "both",
    componentType: "accessories",
    productName: "Accessories",
    model: "Conference Accessories",
    unit: "Lot",
    unitPrice: 12000,
  },
  {
    id: "mugnee-conference-installation",
    brand: "Mugnee Multiple Limited",
    systemType: "both",
    componentType: "installation-service",
    productName: "Installation Testing and Commissioning",
    model: "Installation Service",
    unit: "Job",
    unitPrice: 15000,
  },
];

export const conferenceProducts = rawConferenceProducts;
export const conferenceBrands = ["Spoon", "CMX", "Honeywell", "Bosch"];

export const conferenceTemplates = {
  wired: [
    ["master-control-unit", 1],
    ["chairman-unit", 1],
    ["delegate-unit", 10],
    ["digital-audio-processor", 1],
    ["network-integrated-amplifier", 1],
    ["wall-speaker", 2],
    ["accessories", 1],
    ["installation-service", 1],
  ],
  wireless: [
    ["master-control-unit", 1],
    ["chairman-unit", 1],
    ["delegate-unit", 10],
    ["wireless-access-point", 1],
    ["digital-audio-processor", 1],
    ["network-integrated-amplifier", 1],
    ["wireless-charging-station", 1],
    ["wall-speaker", 2],
    ["accessories", 1],
    ["installation-service", 1],
  ],
};

export const conferenceBrandTemplates = {
  Honeywell: {
    wired: [
      ["master-control-unit", 1],
      ["chairman-unit", 1],
      ["delegate-unit", 10],
      ["network-integrated-amplifier", 1],
      ["wall-speaker", 6],
      ["accessories", 1],
      ["installation-service", 1],
    ],
  },
  Bosch: {
    wired: [
      ["master-control-unit", 1],
      ["chairman-unit", 1],
      ["delegate-unit", 10],
      ["network-integrated-amplifier", 1],
      ["wall-speaker", 4],
      ["accessories", 1],
      ["installation-service", 1],
    ],
  },
};
